
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { FederationDetailStoreReducer } from './reducer';
import { FederationDetailStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, FederationDetailStoreReducer),
		EffectsModule.forFeature([FederationDetailStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class FederationDetailStoreModule { }
